export default __webpack_public_path__ + "static/media/Cloudxier-whychooseus-03.c3fb1170.png";